/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 一括処理
 */
const setScrollTrigger = () => {
  mm.add(mediaQuery__pc, setScrollTrigger__header);
  setScrollTrigger__mv();
  setScrollTrigger__service();
  setScrollTrigger__about();
  setScrollTrigger__instagram();
  setScrollTrigger__access();
};

/**
 * 初期値
 */
const html = document.querySelector('html');
let mm = gsap.matchMedia();
let actionOptions = { duration: 1, ease: 'power1.easeinOut', overwrite: true, }
let triggerOptions = { start: `top 75%`, end: `top 75%`, once: false }
let resizeWindowWidth = window.innerWidth;
let resizeWindowHeight = window.innerHeight;
let mediaQuery__pc = "(min-width: 1025px)";
let mediaQuery__sp = "(max-width: 1024px)";

//リサイズイベント
let timer = false;
function resizeEvent() {
  let resize_width = window.innerWidth;
  if (resizeWindowWidth != resize_width) {
    timer !== false && clearTimeout(timer);
    timer = setTimeout(function () {
      resizeWindowWidth = window.innerWidth;
      resizeWindowHeight = window.innerHeight;
    }, 100);
  }
}
window.addEventListener("orientationchange", resizeEvent);
window.addEventListener("resize", resizeEvent);

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 共通アニメーション
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @param {string} type - fadeIn, fadeUp, text_line, scaleDown
 * @description アニメーションタイプを選択する
 */
function setModule__init(getTrigger, type = '') {

  // フェードイン
  const fadeIn = () => {
    let fadeIn__item = getTrigger.querySelectorAll('.--js_fadeIn__item');
    if (fadeIn__item.length > 0) {
      gsap.set(fadeIn__item, { opacity: 0, });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([fadeIn__item], { ...actionOptions, opacity: 1, stagger: 0.1, }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  // フェードアップ
  const fadeUp = () => {
    let fadeUp__item = getTrigger.querySelectorAll('.--js_fadeUp__item');
    if (fadeUp__item.length > 0) {
      gsap.set(fadeUp__item, { opacity: 0, y: "50%" });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([fadeUp__item], { ...actionOptions, opacity: 1, y: 0, stagger: 0.2, }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  // テキストライン
  const text_line = () => {
    let text_line = getTrigger.querySelectorAll('.line-wrap .line');
    if (text_line.length > 0) {
      gsap.set(text_line, { y: "2em" });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([text_line], { ...actionOptions, y: 0, stagger: 0.1, }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  //シャッター
  const shutter = () => {
    let shutter = getTrigger.querySelectorAll('.--js_shutter__item');
    if (shutter.length > 0) {
      gsap.set(shutter, { scale: 1.3, clipPath: "inset(0 100% 0 0)" });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([shutter], { scale: 1, clipPath: "inset(0 0 0 0)" }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  //animation state
  const animationState = () => {
    let animationState = getTrigger.querySelectorAll('.--js_animationState__item');
    if (animationState.length > 0) {
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([animationState], { animationPlayState: "running" }),
        onEnterBack: () => gsap.to([animationState], { animationPlayState: "paused" }),
        start: `top bottom`, end: `top bottom`, once: false
      });
    }
  }

  //instagram animation state
  const instagramAnimationState = () => {
    let animationState = getTrigger.querySelectorAll('#sbi_images');
    if (animationState.length > 0) {
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([animationState], { animationPlayState: "running" }),
        onEnterBack: () => gsap.to([animationState], { animationPlayState: "paused" }),
        start: `top bottom`, end: `top bottom`, once: false
      });
    }
  }

  type == 'fadeUp' && fadeUp();
  type == 'text_line' && text_line();
  type == 'shutter' && shutter();
  type == 'animationState' && animationState();
  type == 'instagramAnimationState' && instagramAnimationState();
}

/**
 * __00: pin
 * @param {string} getTrigger
 * @param {string} pinTrigger 
 * @param {string} pinTarget
 * @description 次のセクションが被るスクロールアニメーション
 */
function setModule__pinSection(getTrigger, pinTrigger, pinTarget) {
  const pins = getTrigger.querySelectorAll(pinTarget);
  const pinArray = Object.entries(pins);
  const pinSectionOptions = { trigger: pinTrigger, start: "top top", pinSpacing: false, invalidateOnRefresh: true, }
  for (let i = 1; i < pinArray.length + 1; i++) {
    i == 1 ? ScrollTrigger.create({ ...pinSectionOptions, pin: `${pinTarget + i}`, end: "bottom top", }) : ScrollTrigger.create({ ...pinSectionOptions, pin: `${pinTarget + i}`, end: `bottom top-=${i - 1}00%`, });
  }
}

/**
 * __00: header
 * @description スクロールに応じてヘッダーを変化させる
 */
function setScrollTrigger__header() {
  const globalNav__bg = document.querySelector('.globalNav__bg');
  const siteLogo = document.querySelector('.site-header .logo');
  let tl = gsap.timeline({ scrollTrigger: { trigger: html, start: "top top", end: "150px top", ease: 'linear', scrub: 1.5, }, });
  tl.to(globalNav__bg, { scaleY: 1 }, 0);
  tl.to(siteLogo, { y: 9, width: '120px', transition: 'unset' }, 0);
}

/**
 * __01: mv
 * @description mvのスクロールアニメーション
 */
function setScrollTrigger__mv() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.mv');
  setTrigger.forEach((getTrigger) => {
    let img = getTrigger.querySelector('.mv .slider__list');
    let tl = gsap.timeline({ scrollTrigger: { trigger: getTrigger, start: "top top", end: "bottom top", ease: 'Expo.easeInOut', scrub: 1.5 }, });
    tl.to(img, { scale: 1.3, transition: 'unset' }, 0);
  });
}

/**
 * __01: service
 * @description serviceセクションのスクロールアニメーション
 */
function setScrollTrigger__service() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--service');
  let targetEl = document.querySelectorAll('.--service .--js_target');

  setTrigger.forEach((getTrigger) => {
    let triggerOptions = { start: "bottom 50%", end: "bottom 50%" };
    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to(["#service", "#about"], { backgroundColor: '#FFF', duration: 1, ease: 'power1.easeinOut', overflow: true })
        gsap.to([".mv img"], { display: 'none' }, 0);
      },
      onEnterBack: () => {
        gsap.to(["#service", "#about"], { backgroundColor: '#121111', duration: 1, ease: 'power1.easeinOut', overflow: true })
        gsap.to([".mv img"], { display: 'block' }, 0);
      },
      ...triggerOptions,
    });
  })

  targetEl.forEach((getTarget) => {
    setModule__init(getTarget, 'text_line');
    setModule__init(getTarget, 'fadeUp');
    setModule__init(getTarget, 'shutter');
  });
}

/**
 * __01: about
 * @description aboutセクションのスクロールアニメーション
 */
function setScrollTrigger__about() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--about');
  let targetEl = document.querySelectorAll('.--about .--js_target');

  setTrigger.forEach((getTrigger) => {
    //セクションエリア
    const apparel__area = getTrigger.querySelector('.apparel__area');
    const coffee_beer__area = getTrigger.querySelector('.coffee-beer__area');
    const cursor__apparel = getTrigger.querySelector('.cursor__apparel');
    const cursor__coffee_beer = getTrigger.querySelector('.cursor__coffee-beer');

    //セクションエリアに応じて現在のタイトル色を変更
    const current__title = () => {
      const about__title = getTrigger.querySelectorAll('.--about__title h2 > span');
      let tl = gsap.timeline({ scrollTrigger: { trigger: coffee_beer__area, start: "top 50%", end: "top 0%", ease: 'Expo.easeInOut', scrub: 1.5 }, });
      tl.to(about__title[1], { color: '#D9D9D9', }, 0);
      tl.to(about__title[0], { color: '#121111', }, 0);
    }

    //セクションエリアに応じてカーソルボタンを表示・非表示(SP用)
    const cursor__toggle = (trigger, target) => {
      let cursor__triggerOptions = { start: "25% 75%", end: "100% 75%", once: false, }
      ScrollTrigger.batch(trigger, {
        onEnter: () => target.classList.add('--is-show'),
        onLeave: () => target.classList.remove('--is-show'),
        onEnterBack: () => target.classList.add('--is-show'),
        onLeaveBack: () => target.classList.remove('--is-show'),
        ...cursor__triggerOptions,
      });
    }

    //Coffee&Beerセクションのスクロールアニメーション
    const about__coffee_beer__text = () => {
      let trigger = getTrigger.querySelectorAll('.box');
      let target01 = getTrigger.querySelectorAll('.--about__coffee .text-box');
      let target02 = getTrigger.querySelectorAll('.--about__beer .text-box');
      let about__coffee_beer__text__triggerOptions = { start: "80% 48px", end: "80% 48px", once: false }
      gsap.set(target02, { opacity: 0, y: '30%' });
      ScrollTrigger.batch(trigger, {
        onEnter: () => gsap.to(target01, { opacity: 0, y: '-30%', ...actionOptions }),
        onLeave: () => gsap.to(target02, { opacity: 1, y: 0, ...actionOptions }),
        onEnterBack: () => gsap.to(target02, { opacity: 0, y: '30%', ...actionOptions }),
        onLeaveBack: () => gsap.to(target01, { opacity: 1, y: 0, ...actionOptions }),
        ...about__coffee_beer__text__triggerOptions,
      });
    }

    const about__coffee_beer__img = () => {
      let trigger = getTrigger.querySelectorAll('.box');
      let target01 = getTrigger.querySelectorAll('.--about__coffee img');
      let target02 = getTrigger.querySelectorAll('.--about__beer img');
      gsap.set([target02], { scale: 1.2 });
      let tl = gsap.timeline({ scrollTrigger: { trigger: trigger[0], start: "top top", end: "bottom top", ease: 'Expo.easeInOut', scrub: 1.5 }, });
      tl.to(target02, { scale: 1, transition: 'unset' }, 0)
        .to(target01, { scale: 1.2, transition: 'unset' }, "<");
    }

    mm.add(mediaQuery__pc, () => {
      current__title();
      setModule__pinSection(getTrigger, ".--about__coffee", ".--js_pin");
      about__coffee_beer__text();
      about__coffee_beer__img();
    });

    mm.add(mediaQuery__sp, () => {
      cursor__toggle(apparel__area, cursor__apparel);
      cursor__toggle(coffee_beer__area, cursor__coffee_beer);
    });
    
    setModule__init(getTrigger, 'animationState');
  });

  targetEl.forEach((getTarget) => {
    setModule__init(getTarget, 'text_line');
    setModule__init(getTarget, 'fadeUp');
    setModule__init(getTarget, 'shutter');
  });
}

/**
 * __01: instagram
 * @description instagramセクションのスクロールアニメーション
 */
function setScrollTrigger__instagram() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--instagram');
  setTrigger.forEach((getTrigger) => {
    setModule__init(getTrigger, 'instagramAnimationState');
  });
}

/**
 * __01: access
 * @description accessセクションのスクロールアニメーション
 */
function setScrollTrigger__access() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--access');
  setTrigger.forEach((getTrigger) => {
    setModule__init(getTrigger, 'animationState');
  });
}


/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setScrollTrigger
};